import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const useUserProfile = () => {
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [photoURL, setPhotoURL] = useState('');
  const [titulo, setTitulo] = useState('');
  const [showProfessionalTab, setShowProfessionalTab] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (user) {
        setNome(user.displayName || '');
        setEmail(user.email || '');
        setPhotoURL(user.photoURL || '');

        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setCpf(data.cpf || '');
          setTitulo(data.titulo || '');
          setShowProfessionalTab(
            data.titulo === 'Dr.' || data.titulo === 'Dra.'
          );
        }
      }
    };

    fetchUserProfile();
  }, [user, db]);

  return {
    nome,
    email,
    cpf,
    photoURL,
    titulo,
    showProfessionalTab,
    setNome,
    setEmail,
    setCpf,
    setPhotoURL,
    setTitulo,
    setShowProfessionalTab,
  };
};

export default useUserProfile;
